module.exports = function({ appId, callback = () => {} }) {
    window.fbAsyncInit = function() {
        window.FB.init({
            appId: appId,
            xfbml: true,
            status: true, // check login status
            cookie: true, // enable cookies to allow the server to access the session
            // oauth: true,
            version: 'v3.0'
        });

        callback();

        //   if (onCheckboxClick) {
        //     console.log('Add messenger checkbox subscribe')
        //     window.FB.Event.subscribe("messenger_checkbox", function(e) {
        //       console.log("ASDASDADADASD DAJSKHDJAKSDHADHASDK");
        //       if (e.event == "rendered") {
        //         console.log("Plugin was rendered");
        //       } else if (e.event == "checkbox") {
        //         var checkboxState = e.state;
        //         console.log("MESSENGER OPTIN DAMN");
        //         // onCheckboxClick(checkboxState);
        //       } else if (e.event == "hidden") {
        //         console.log("Plugin was hidden");
        //       }
        //     });
        //   }
    };

    (function(d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk/debug.js';
        fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
};



/** WEBPACK FOOTER **
 ** ../src/common/facebookMessengerAsyncInit.js
 **/